import React, { Component } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { deleteMessage } from "actions/newWorkOrderActions";

class FlashMessage extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { type } = this.props.message;
    if (prevProps.message.type !== type && type === "error") {
      this.messageTimeouts.forEach(t => clearTimeout(t));
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.message !== "" &&
      (this.props.message.type === "error" ||
        this.props.message.type === "info") &&
      nextProps.url !== this.props.url
    ) {
      this.props.deleteMessage();
    }
  }

  onClick() {
    this.props.deleteMessage();
  }

  messageTimeouts = [];

  render() {
    const { type, text } = this.props.message;
    if (type === "success") {
      this.messageTimeouts.push(
        setTimeout(() => {
          this.props.deleteMessage();
        }, 10000)
      );
    }

    if (text) {
      return (
        <div
          className={classnames(
            "alert",
            { "alert-success": type === "success" },
            { "alert-info": type === "info" },
            { "alert-danger": type === "error" }
          )}
        >
          <button onClick={this.onClick} className="close">
            <span>&times;</span>
          </button>
          {text}
        </div>
      );
    }
    return null;
  }
}

FlashMessage.propTypes = {
  url: PropTypes.string
};

const mapStateToProps = state => {
  return {
    message: state.message
  };
};

const mapDispathToProps = {
  deleteMessage
};
export default connect(mapStateToProps, mapDispathToProps)(FlashMessage);
